import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Reset scroll to the top on every route change (but not on in-page #hash nav).
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
